import { useTranslations } from "@src/packages/i18n";
import type { PlanAction } from "../plan.types";
import { OrganicMiniIcon } from "./OrganicMiniIcon";
import { JourneyHandoffCard } from "./JourneyHandoffCard";

const silkBrown =
  require("@src/apps/moon/assets/images/silk-brown.png") as number;

export function SpermFreezingStartStep({
  onAction,
}: {
  onAction: (action: PlanAction) => void;
}) {
  const t = useTranslations();
  return (
    <JourneyHandoffCard
      title={t("homepage.sperm_freezing_start.title")}
      body={t("homepage.sperm_freezing_start.body")}
      ctaLabel={t("homepage.sperm_freezing_start.set_banking_start")}
      checklist={[
        t("homepage.sperm_freezing_start.collection_timing"),
        t("homepage.sperm_freezing_start.abstinence_window"),
        t("homepage.sperm_freezing_start.sample_reports"),
        t("homepage.sperm_freezing_start.storage_plan"),
      ]}
      backgroundImage={silkBrown}
      illustration={<OrganicMiniIcon kind="cryo" size={92} />}
      onPress={() =>
        onAction({
          label: t("homepage.sperm_freezing_start.set_banking_start"),
          signal: "open-start-treatment-modal",
          params: { presetCycleType: "sperm_freezing" },
        })
      }
    />
  );
}
